import request from '@/utils/request'



// 查询参数列表
export function diyPageList (query) {
  return request({
    url: '/sys/diyPage/list',
    method: 'get',
    params: query
  })
}


// 修改
export function diyPageEdit (data) {
  return request({
    url: '/sys/diyPage/edit',
    method: 'post',
    data: data
  })
}

// 添加
export function diyPageAdd (data) {
  return request({
    url: '/sys/diyPage/add',
    method: 'post',
    data: data
  })
}
